module.exports = __webpack_public_path__ + "img/PURA.d6b4fcfd.svg";